import React from 'react';
import { CheckCircle } from 'lucide-react';

export const SuccessAnimation: React.FC = () => {
  return (
    <div className="mb-8 flex justify-center">
      <div className="relative">
        {/* Animated ping circles */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-24 h-24 rounded-full bg-green-500/20 animate-ping" />
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <div 
            className="w-20 h-20 rounded-full bg-green-500/30 animate-ping" 
            style={{ animationDelay: '0.2s' }}
          />
        </div>

        {/* Check icon */}
        <div 
          className="relative w-24 h-24 rounded-full bg-gradient-to-br from-green-400 to-green-600 flex items-center justify-center shadow-lg shadow-green-500/30"
          style={{
            animation: 'scaleIn 0.5s ease-out forwards',
          }}
        >
          <CheckCircle className="w-14 h-14 text-white" strokeWidth={2.5} />
        </div>

        {/* Confetti-like decorations */}
        <div className="absolute -top-2 -right-2 w-4 h-4 bg-secondary rounded-full animate-bounce" style={{ animationDelay: '0.3s' }} />
        <div className="absolute -bottom-1 -left-3 w-3 h-3 bg-primary rounded-full animate-bounce" style={{ animationDelay: '0.5s' }} />
        <div className="absolute top-0 -left-4 w-2 h-2 bg-yellow-400 rounded-full animate-bounce" style={{ animationDelay: '0.7s' }} />
      </div>

      <style>{`
        @keyframes scaleIn {
          0% {
            transform: scale(0);
            opacity: 0;
          }
          50% {
            transform: scale(1.1);
          }
          100% {
            transform: scale(1);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export default SuccessAnimation;
